/** @format */

import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button } from '.';

const Backbtn = props => {
  const { t } = useTranslation();
  const backLink = props.kb ? `/knowledge-base/${props.kb}` : props.isNews ? `/news` : '/';
  const backLabel =
    props.kb || props.isNews ? t('backToAllArticlesBtn') : t('backbtn');
  return (
    <>
      <div className="btn-container" style={{ viewTransitionName: 'back-btn' }}>
        <Link to={backLink}>
          <Button borderOnly back label={backLabel} />
        </Link>
      </div>
    </>
  );
};

export { Backbtn };
